import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import { BookmakerDataType } from "../../../types/bookmaker";
import { ActionType } from "../../../types/reducer";
import CheckCircle from "../CheckCircle";
import {
  RowContainer,
  Name,
  BookmakerLogo,
  BestIcon,
  BookmakerContainer,
  Description,
} from "./styles";
import BestOddsLogo from "../../../assets/Badge_Badge_Best_Odds_6.png";
import BestLineLogo from "../../../assets/Badge_Badge_Best_Odds_7.png";

interface Props {
  bookmaker?: BookmakerDataType;
  oddsFilter?: string;
}

const CDN_PATH = process.env.REACT_APP_BETTING_HUB_CDN_ENDPOINT;

export default function BookmakerRow({
  bookmaker,
  oddsFilter,
}: Props): JSX.Element {
  const dispatch = useDispatch();

  const appStore = useSelector((state: RootState) => state.app);
  const activeBookmaker = appStore && appStore["activeBookmaker"];
  const toggleShowBestOdds = appStore && appStore["showBestOdds"];

  const getBookmakerName = (id: string, name: string | null) => {
    switch (id) {
      case 'bestodds':
        return 'Best Odds';
      case 'bestline':
        return 'Best Line';
      default:
        return name;
    }
  }

  const renderBookmaker = (id: string, name: string | null) => {
    dispatch({
      type: ActionType.ACTIVE_BOOKMAKER,
      payload: id,
    });
    dispatch({
      type: ActionType.ACTIVE_BOOKMAKER_NAME,
      payload: getBookmakerName(id, name),
    });
    dispatch({
      type: ActionType.BESTODDS,
      payload: !toggleShowBestOdds,
    });
  };

  const renderBestRow = () => {
    if (oddsFilter === "bestodds")
      return (
        <BookmakerContainer>
          <BestIcon src={BestOddsLogo} alt={oddsFilter} loading="lazy" />
          <Name>
            Best Odds{" "}
            <Description>Always show the best odds available</Description>
          </Name>
        </BookmakerContainer>
      );
    return (
      <BookmakerContainer>
        <BestIcon src={BestLineLogo} alt={oddsFilter} loading="lazy" />
        <Name>
          Best Line{" "}
          <Description>Always show the best line available</Description>
        </Name>
      </BookmakerContainer>
    );
  };

  if (bookmaker)
    return (
      <RowContainer
        key={bookmaker.id}
        onClick={() => renderBookmaker(bookmaker.id, bookmaker.name)}
      >
        <BookmakerContainer>
          <BookmakerLogo>
            <source
              srcSet={`${CDN_PATH}/bookies/web/${bookmaker.id.replace(
                "_",
                ""
              )}.webp`}
              type="image/webp"
            />
            <source
              srcSet={`${CDN_PATH}/bookies/web/${bookmaker.id.replace(
                "_",
                ""
              )}.png`}
              type="image/png"
            />
            <img
              src={`${CDN_PATH}/bookies/web/${bookmaker.id.replace(
                "_",
                ""
              )}.png`}
              alt={bookmaker.name}
              loading="lazy"
            />
          </BookmakerLogo>
          <Name>{bookmaker.name}</Name>
        </BookmakerContainer>
        <CheckCircle selected={activeBookmaker === bookmaker.id} />
      </RowContainer>
    );

  return (
    <RowContainer
      solidBorder
      onClick={() => (oddsFilter ? renderBookmaker(oddsFilter, null) : {})}
    >
      {renderBestRow()}
      <CheckCircle selected={activeBookmaker === oddsFilter} />
    </RowContainer>
  );
}
